<div class="card-header p-0">
    <div *ngIf="forMerchants" class="parking-status">
        <span
            [ngClass]="{
                'bg-light': parking.parkingStatus == parkingStatus.NEW,
                'bg-warning': parking.parkingStatus == parkingStatus.PENDING,
                'bg-success': parking.parkingStatus == parkingStatus.PUBLISHED
            }"
            class="badge rounded-pill text-dark"
        >{{ parking.parkingStatus }}</span
        >
    </div>
    <carousel (activeSlideChange)="activeSlideChange($event)" *ngIf="images.length > 0" [class]="'gallery-carousel'">
        <slide *ngFor="let image of images; let i = index">
            <img *ngIf="i <= highestIndex" [src]="image.smallUrl" class="w-100" />
        </slide>
    </carousel>
    <div class="no-image-icon">
        <i class="fa fa-image"></i>
    </div>
    <img class="w-100" src="/assets/images/parking/no_image.png" />
</div>
<div class="card-body">
    <div *ngIf="forMerchants" class="mb-2">
        <span class="badge rounded-pill text-dark bg-primary">ReserveUpp</span>
    </div>
    <h5 class="card-title">
        {{ parking.title || 'Unnamed Parking' }}
    </h5>
</div>
